var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.337,
    height: 65.335,
    viewBox: "0 0 65.337 65.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_013-news",
    "data-name": "013-news",
    d: "M50.023,65.342H15.314A15.33,15.33,0,0,1,0,50.029V34.716A12.738,12.738,0,0,1,10.082,22.211V15.32A15.33,15.33,0,0,1,25.4.007H50.023A15.33,15.33,0,0,1,65.336,15.32V50.029A15.33,15.33,0,0,1,50.023,65.342ZM10.082,27.495a7.557,7.557,0,0,0-4.977,7.221V50.029A10.22,10.22,0,0,0,15.314,60.238H50.023A10.22,10.22,0,0,0,60.232,50.029V15.32A10.22,10.22,0,0,0,50.023,5.111H25.4A10.22,10.22,0,0,0,15.187,15.32v35.22a2.552,2.552,0,0,1-5.1,0ZM55.128,16.468a2.552,2.552,0,0,0-2.552-2.552H22.843a2.552,2.552,0,0,0,0,5.1H52.576A2.552,2.552,0,0,0,55.128,16.468Zm.128,23.863A2.552,2.552,0,0,0,52.7,37.779H42.75a2.552,2.552,0,0,0,0,5.1H52.7A2.552,2.552,0,0,0,55.255,40.331Zm-20.034,0a2.552,2.552,0,0,0-2.552-2.552H22.843a2.552,2.552,0,0,0,0,5.1h9.826A2.552,2.552,0,0,0,35.221,40.331Zm0,10.209a2.552,2.552,0,0,0-2.552-2.552H22.843a2.552,2.552,0,0,0,0,5.1h9.826A2.552,2.552,0,0,0,35.221,50.54Zm14.8,0a2.552,2.552,0,0,0-2.552-2.552H42.75a2.552,2.552,0,0,0,0,5.1h4.721A2.552,2.552,0,0,0,50.023,50.54ZM52.7,32.675H34.2a2.552,2.552,0,0,1,0-5.1H52.7A2.552,2.552,0,0,1,52.7,32.675ZM20.291,29.867a3.19,3.19,0,1,0,3.19-3.19A3.19,3.19,0,0,0,20.291,29.867Z",
    transform: "translate(0 -0.007)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPost);
export default __webpack_public_path__ + "static/media/ic_post.a30e96e9b85d67f37192fd29bdb94454.svg";
export { ForwardRef as ReactComponent };